import { render } from "./ModalClipRight.vue?vue&type=template&id=4a226cff&scoped=true"
import script from "./ModalClipRight.vue?vue&type=script&lang=js"
export * from "./ModalClipRight.vue?vue&type=script&lang=js"

import "./ModalClipRight.vue?vue&type=style&index=0&id=4a226cff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a226cff"]])

export default __exports__